<template>
  <!-- 单选按钮 -->
  <jw-radio-group v-if="isQuoteRadio" class="system-form-item-fields" v-model="modulesItem.fieldValue" @change="handleChange" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll">
    <jw-radio v-for="item in JSON.parse(optionsList)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-radio>
  </jw-radio-group>
  <!-- 多选按钮 -->
  <jw-checkbox-group v-else class="system-form-item-fields" v-model="modulesItem.fieldValue" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange">
    <jw-checkbox v-for="item in JSON.parse(optionsList)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-checkbox>
  </jw-checkbox-group>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const isQuoteRadio = computed(() => {
  return props.modules?.setting?.fieldType === 2 || props.modules?.setting?.business?.fieldType == 2;
});

const optionsList = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
});

const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './radio.less';
</style>
